import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorResponse } from 'src/app/core/models/common.models';
import { IdeasBackendService } from 'src/app/core/services/backend/ideas-backend.service';
import {
  IdeasReqTrackAction,
  IdeasReqTrackErrorAction,
  IdeasReqTrackSuccessAction,
  IdeasReqUntrackAction,
  IdeasReqUntrackErrorAction,
  IdeasReqUntrackSuccessAction,
} from 'src/app/core/store/actions/ideas';
import { CoreState } from '../reducers';

@Injectable({
  providedIn: 'root',
})
export class IdeasTrackStoreService {
  constructor(
    private bs: IdeasBackendService, //
    private store$: Store<CoreState>,
  ) {}

  public track(ideaId: string): Observable<string> {
    this.store$.dispatch(new IdeasReqTrackAction(ideaId));

    return this.bs.track(ideaId).pipe(
      map((res) => {
        this.store$.dispatch(new IdeasReqTrackSuccessAction(res));
        return res;
      }),
      catchError((err: ErrorResponse) => {
        this.store$.dispatch(new IdeasReqTrackErrorAction(err));
        return throwError(() => err);
      }),
    );
  }

  public untrack(ideaId: string): Observable<string> {
    this.store$.dispatch(new IdeasReqUntrackAction(ideaId));

    return this.bs.untrack(ideaId).pipe(
      map((res) => {
        this.store$.dispatch(new IdeasReqUntrackSuccessAction(res));
        return res;
      }),
      catchError((err: ErrorResponse) => {
        this.store$.dispatch(new IdeasReqUntrackErrorAction(err));
        return throwError(() => err);
      }),
    );
  }
}
